import { useEffect } from "react";
import { Monitor, Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useStore, type ThemeChoice } from "@/lib/store.ts";
import { syncThemeColor } from "@/lib/themeColor.ts";

const NEXT: Record<ThemeChoice, ThemeChoice> = { system: "light", light: "dark", dark: "system" };
const LABEL: Record<ThemeChoice, string> = { system: "Theme: follow system", light: "Theme: light", dark: "Theme: night" };

/** Applies the chosen theme to <html>; "system" follows the OS live. */
export function useApplyTheme() {
  const theme = useStore((s) => s.theme);
  useEffect(() => {
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const apply = () => document.documentElement.classList.toggle("dark", theme === "dark" || (theme === "system" && mq.matches));
    apply();
    syncThemeColor(theme);
    mq.addEventListener("change", apply);
    return () => mq.removeEventListener("change", apply);
  }, [theme]);
}

export function ThemeToggle() {
  const theme = useStore((s) => s.theme);
  const setTheme = useStore((s) => s.setTheme);
  const Icon = theme === "system" ? Monitor : theme === "light" ? Sun : Moon;
  return (
    <Button variant="ghost" size="icon" onClick={() => setTheme(NEXT[theme])} aria-label={LABEL[theme]} title={LABEL[theme]} className="size-9">
      <Icon className="size-[1.15rem]" aria-hidden />
    </Button>
  );
}
